'use client';
/** @jsxImportSource @emotion/react */

import { type ComponentProps, type PropsWithChildren } from 'react';

import { type Theme } from '@mui/material';

import { IconProvider } from '../context/IconContext';
import {
  MediaQueryProvider,
  type SSRMatchMedia,
} from '../context/MediaQueryContext';
import { ThemeProvider } from '../theme/ThemeProvider';

interface Props {
  icons?: ComponentProps<typeof IconProvider>['icons'];
  theme: Theme;
  ssrMatchMedia?: SSRMatchMedia;
}

export const ZeusProvider = ({
  children,
  icons,
  theme,
  ssrMatchMedia,
}: PropsWithChildren<Props>) => {
  return (
    <ThemeProvider theme={theme}>
      <IconProvider icons={icons}>
        <MediaQueryProvider ssrMatchMedia={ssrMatchMedia}>
          {children}
        </MediaQueryProvider>
      </IconProvider>
    </ThemeProvider>
  );
};
